window.waitFor = (f, t) => new Promise((res, rej) => {
    const timeWas = new Date()
    const wait = setInterval(() => {
      if (f()) {
        clearInterval(wait)
        res()
      } else if (new Date() - timeWas > t) {
        clearInterval(wait)
        rej()
      }
    }, 50)
  });